import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  whiteTooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.secondary,
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.body2.fontWeight,
    border: `1px solid ${theme.palette.divider}`,
    textAlign: 'justify',
    maxWidth: 400,
  },
  whiteTooltipArrow: {
    color: theme.palette.common.white,
    '&:before': {
      border: `1px solid ${theme.palette.divider}`,
    },
  },
  daiChip: {
    backgroundColor: theme.palette.info.main,
    color: theme.palette.info.contrastText,
  },
  daiInfo: {
    color: theme.palette.info.main,
  },
}))

export default styles
